import styled from 'styled-components';
import * as typography from 'components/mixins/typography';
import media from 'components/mixins/media';
import { transparentize } from 'utils/color';
import { defaultBoxShadowColor } from 'constants/common';

const LinkCuration = styled.div`
  [data-type*='linkCuration'] {
    display: flex;
    flex-direction: column;

    .custom-description {
      ${typography.secondaryFontText};

      & :last-child {
        margin-bottom: 40px;
      }
    }

    .content-inner-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      max-width: calc(100% - 8px);
      height: 195px;
      box-shadow: 0 2px 10px 0 ${transparentize(defaultBoxShadowColor, 0.1)};
      background-color: ${props => props.theme.colors.contentBodyColor};
      box-sizing: border-box;
      margin: 4px 4px 6px;

      a {
        color: ${props => props.theme.colors.textColor};
        text-decoration: none;
        ${typography.secondaryFontText};

        .images {
          &.parsed {
            display: flex;
            overflow: hidden;
            position: relative;
            margin: auto 40px auto 30px;

            .image-wrapper {
              display: flex;
              margin: auto;
              align-items: center;
              justify-content: center;
            }
          }

          &.deleted {
            padding-left: 20px;
          }
        }

        img {
          margin: auto;
          max-width: 200px;
          max-height: 135px;
        }
      }

      .text-wrapper {
        min-width: 1px;
        height: 100%;
        padding-right: 20px;

        .text-block {
          width: 100%;
          text-decoration: none;
          margin-top: 15px;

          .link-title {
            height: 44px;
            ${typography.mainFontH4};
            text-align: left;
            vertical-align: middle;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .link-content {
            max-height: 60px;
            margin-bottom: 25px;
            font-size: 14px;
            line-height: 28px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }

        .static-link-present {
          max-height: 25px;

          a {
            display: block;
            width: 100%;
            max-height: 20px;
            color: ${props => props.theme.colors.mainColor};
            font-size: 15px;
            text-decoration: underline;
            line-height: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.link-url {
              text-decoration: none;
            }

            &::before {
              content: '\f110';
              position: relative;
              bottom: -2px;
              display: inline-block;
              margin-right: 15px;
              font-family: 'custom-icons';
              font-size: 12px;
              color: ${props => transparentize(props.theme.colors.textColor, 0.2)};
              text-decoration: none;
              transition: all 0.1s ease-in-out;
            }

            &:hover {
              color: ${props => transparentize(props.theme.colors.mainColor, 0.8)};

              &::before {
                color: ${props => transparentize(props.theme.colors.mainColor, 0.8)};
              }
            }
          }
        }
      }
      ${media.mobile`
        flex-direction: column;
        max-width: calc(100% - 8px);
        height: 100%;
        max-height: 372px;

        a {
          img {
            margin: auto;
            max-width: 205px;
            max-height: 135px;
          }
          .images {
            &.parsed {
              margin: 20px;
            }

            &.deleted {
              padding-top: 20px;
            }
          }
        }

        .text-wrapper {
          width: auto;
          max-width: 100%;
          height: auto;
          padding: 0 20px 40px;

          .text-block {
            margin-top: 0;

            .link-title {
              &.empty {
                display: none;
              }
            }

            .link-content {
              max-height: 78px;
              margin-bottom: 20px;
              font-size: 13px;
              line-height: 2;
            }
          }
        }
      `};

      @media (min-width: 580px) and (max-width: 1000px) {
        max-width: calc(100% - 8px);

        a {
          img {
            margin: auto;
            max-width: 160px;
            max-height: 107px;
          }
        }

        .text-wrapper {
          .text-block {
            .link-content {
              max-height: 90px;
              line-height: 2.14;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
`;

export default LinkCuration;
